import { getCountryDataList } from 'countries-list';

export const countries = getCountryDataList().map((country) => ({
  value: country.iso2,
  label: country.name,
}));

export const useCountries = (location: string) => {
  const countryLabel = useMemo(() => {
    return countries.find((country) => country.value === location)?.label || '';
  }, [location]);

  return { countries, countryLabel };
};
